// axios counterpart to authSessionGuard.js. None of the ~50 components that
// call axios directly use axios.create() — they all import the default
// `axios` singleton — so attaching interceptors here once, at app startup,
// covers every axios call in the app without touching those call sites.
//
// Same contract as the fetch guard: on a 401 "token_not_valid" response,
// silently refresh and retry the original request once; only a failed
// refresh (or a request that isn't a token issue) falls through as a
// rejected promise / logout, exactly like an un-intercepted axios call
// would already behave for any other error.
import axios from 'axios';
import { refreshAccessToken, forceLogout } from './tokenRefresh';

axios.interceptors.response.use(
    (response) => response,
    async (error) => {
        const { response, config } = error;

        if (
            response &&
            response.status === 401 &&
            response.data &&
            response.data.code === 'token_not_valid' &&
            localStorage.getItem('access_token') &&
            config &&
            !config._retry
        ) {
            config._retry = true;
            const refreshed = await refreshAccessToken();
            if (refreshed) {
                config.headers = {
                    ...(config.headers || {}),
                    Authorization: `Bearer ${localStorage.getItem('access_token')}`,
                };
                return axios(config);
            }
            forceLogout();
        }

        return Promise.reject(error);
    }
);
